<template>
  <v-layout wrap justify-center>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#68D389"
      size="128"
      is-full-screen
    />
    <ServerError v-if="ServerError"/>
    <v-flex xs12 px-8 pb-5 align-self-center>
      <v-layout>
        <v-flex>
          <v-dialog v-model="value" width="900px" v-if="turtleList.turtleImage" >
                <v-card >
                <v-img
            width="900"
          contain
            :src="baseURL + turtleList.turtleImage"
          ></v-img>
                </v-card>
              </v-dialog>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-dialog v-model="value1" width="900px"  >
                <v-card >
                <v-img
            width="900"

          contain
            :src="baseURL + item"
          ></v-img>
                </v-card>
              </v-dialog>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-start>
    
          <!-- <v-layout wrap style="background-color:red">
            <v-felx md4 style="background-color:green">
          <v-img
            width="400"
            height="400"
            contain
            :src="baseURL + turtleList.turtleImage"
          ></v-img>
          </v-felx>

            <v-flex md4 style="background-color:gray" pt-12>
              <v-layout wrap>
            <v-flex xs12 py-lg-8 align-self-center>
              <span style="font-family: poppins-semibold; font-size: 26px">
                {{ turtleList.name }}
              </span>
            </v-flex>
            <v-flex xs12 pb-lg-3 align-self-center>
              <span style="font-family: poppins-semibold; font-size: 21px"
                >Legal Protection</span
              >
            </v-flex>
            <v-flex xs12 sm3 text-left align-self-center>
              <span style="font-family: poppins-regular; font-size: 19px"
                >WLPA</span
              >
            </v-flex>
            <v-flex xs12 sm9 text-left align-self-center>
              <span style="font-family: poppins-light; font-size: 19px">{{
                turtleList.wlpa
              }}</span>
            </v-flex>
            <v-flex xs12 sm3 text-left align-self-center>
              <span style="font-family: poppins-regular; font-size: 19px"
                >CITES</span
              >
            </v-flex>
            <v-flex xs12 sm9 text-left align-self-center>
              <span style="font-family: poppins-light; font-size: 19px">{{
                turtleList.cites
              }}</span>
            </v-flex>
            <v-flex xs12 sm3 text-left align-self-center>
              <span style="font-family: poppins-regular; font-size: 19px"
                >IUCN</span
              >
            </v-flex>
            <v-flex xs12 sm9 text-left align-self-center>
              <span style="font-family: poppins-light; font-size: 19px">{{
                turtleList.iucn
              }}</span>
            </v-flex>
             </v-layout>
             
            </v-flex>
            <v-flex md12 lg4 @click="big" style="background-color:yellow" pt-12 >
              <template>
            <v-carousel height="270px" hide-delimiters>
              <v-carousel-item v-for="(item, i) in carousel" :key="i">
             <v-img contain :src="baseURL + item"></v-img>
              </v-carousel-item>
            </v-carousel>
              </template>
            </v-flex>
          
          </v-layout> -->
        
        <v-flex xs12>
         <v-layout wrap>
           <v-flex md4 align-self-center>
             <v-img  @click="big"
            width="400"
            height="400"
            contain
            :src="baseURL + turtleList.turtleImage"
          ></v-img></v-flex>
           <v-flex md4 align-self-center  pl-md-3 pt-lg-0 >
                <v-layout wrap>
            <v-flex xs12 py-lg-8  align-self-center>
              <span style="font-family: poppins-semibold; font-size: 26px">
                {{ turtleList.name }}
              </span>
            </v-flex>
            <v-flex xs12 pb-lg-3 align-self-center>
              <span style="font-family: poppins-semibold; font-size: 21px"
                >Legal Protection</span
              >
            </v-flex>
            <v-flex xs12 sm3 text-left align-self-center>
              <span style="font-family: poppins-regular; font-size: 19px"
                >WLPA</span
              >
            </v-flex>
            <v-flex xs12 sm9 text-left align-self-center>
              <span style="font-family: poppins-light; font-size: 19px">{{
                turtleList.wlpa
              }}</span>
            </v-flex>
            <v-flex xs12 sm3 text-left align-self-center>
              <span style="font-family: poppins-regular; font-size: 19px"
                >CITES</span
              >
            </v-flex>
            <v-flex xs12 sm9 text-left align-self-center>
              <span style="font-family: poppins-light; font-size: 19px">{{
                turtleList.cites
              }}</span>
            </v-flex>
            <v-flex xs12 sm3 text-left align-self-center>
              <span style="font-family: poppins-regular; font-size: 19px"
                >IUCN</span
              >
            </v-flex>
            <v-flex xs12 sm9 text-left align-self-center>
              <span style="font-family: poppins-light; font-size: 19px">{{
                turtleList.iucn
              }}</span>
            </v-flex>
             </v-layout>
           </v-flex>
           <v-flex pt-5  md4 pt-md-3 pt-lg-0 align-self-center >
              <template>
                
            <v-carousel height="100%" hide-delimiters>
              
              <v-carousel-item  @click="big2(item)" v-for="(item, i) in carousel" :key="i">  
                <v-sheet height="100%"  >
             <v-img contain height="270px" :src="baseURL + item"></v-img>
             </v-sheet>
              </v-carousel-item>
              
            </v-carousel>
              </template>
           </v-flex>

         </v-layout>
        </v-flex>

        <v-flex>
          <v-layout wrap>
        <v-flex xs12 py-2 align-self-center text-left>
          <span
            style="color: red; font-family: poppins-semibold; font-size: 23px"
          >
            Threats
          </span>
        </v-flex>
        <v-flex xs12 align-self-center text-left>
          <span style="color: red; font-family: poppins-light; font-size: 23px">
            {{ turtleList.threats }}
          </span>
        </v-flex>
        <v-flex xs12 sm3 py-2>
          <span
            style="color: black; font-family: poppins-semibold; font-size: 23px"
          >
            Scientific Name
          </span>
        </v-flex>
        <v-flex xs12 sm9 align-self-center text-left>
          <span
            style="color: black; font-family: poppins-lighti; font-size: 21px"
          >
            {{ turtleList.sci_name }}
          </span>
        </v-flex>
        <v-flex xs12 sm3 py-2>
          <span
            style="color: black; font-family: poppins-semibold; font-size: 23px"
          >
            Local Name
          </span>
        </v-flex>
        <v-flex xs12 sm9 py-2 align-self-center text-left>
          <span
            style="color: black; font-family: poppins-light; font-size: 21px"
          >
            {{ turtleList.common_name }}
          </span>
        </v-flex>
        <v-flex xs12 sm3 py-2>
          <span
            style="color: black; font-family: poppins-semibold; font-size: 23px"
          >
            Morphology
          </span>
        </v-flex>
        <v-flex xs12 sm9 py-2 align-self-center text-left>
          <span
            style="color: black; font-family: poppins-light; font-size: 21px"
          >
            {{ turtleList.morphology }}
          </span>
        </v-flex>
        <v-flex xs12 sm3 py-2>
          <span
            style="color: black; font-family: poppins-semibold; font-size: 23px"
          >
            Habitat
          </span>
        </v-flex>
        <v-flex xs12 sm9 py-2 align-self-center text-left>
          <span
            style="color: black; font-family: poppins-light; font-size: 21px"
          >
            {{ turtleList.habitat }}
          </span>
        </v-flex>

        <v-flex xs12 sm3 py-2>
          <span
            style="color: black; font-family: poppins-semibold; font-size: 23px"
          >
            Dimorphism
          </span>
        </v-flex>
        <v-flex xs12 sm9 py-2 align-self-center text-left>
          <span
            style="color: black; font-family: poppins-light; font-size: 21px"
          >
            {{ turtleList.dimorphism }}
          </span>
        </v-flex>

        <v-flex xs12 sm3 py-2>
          <span
            style="color: black; font-family: poppins-semibold; font-size: 23px"
          >
            Diet
          </span>
        </v-flex>
        <v-flex xs12 sm9 py-2 align-self-center text-left>
          <span
            style="color: black; font-family: poppins-light; font-size: 21px"
          >
            {{ turtleList.diet }}
          </span>
        </v-flex>

        <v-flex xs12 sm3 py-2>
          <span
            style="color: black; font-family: poppins-semibold; font-size: 23px"
          >
            Nesting
          </span>
        </v-flex>
        <v-flex xs12 sm9 py-2 align-self-center text-left>
          <span
            style="color: black; font-family: poppins-light; font-size: 21px"
          >
            {{ turtleList.nesting }}
          </span>
        </v-flex>

        <v-flex xs12 sm3 py-2>
          <span
            style="color: black; font-family: poppins-semibold; font-size: 23px"
          >
            Color
          </span>
        </v-flex>
        <v-flex xs12 sm9 py-2 align-self-center text-left>
          <span
            style="color: black; font-family: poppins-light; font-size: 21px"
          >
            {{ turtleList.color }}
          </span>
        </v-flex>

        <v-flex xs12 sm3 py-2>
          <span
            style="color: black; font-family: poppins-semibold; font-size: 23px"
          >
            Size
          </span>
        </v-flex>
        <v-flex xs12 sm9 py-2 align-self-center text-left>
          <span
            style="color: black; font-family: poppins-light; font-size: 21px"
          >
            {{ turtleList.size }}
          </span>
        </v-flex>

        <v-flex xs12 sm3 py-2>
          <span
            style="color: black; font-family: poppins-semibold; font-size: 23px"
          >
            Global Distribution
          </span>
        </v-flex>
        <v-flex xs12 sm9 py-2 align-self-center text-left>
          <span
            style="color: black; font-family: poppins-light; font-size: 21px"
          >
            {{ turtleList.distribution }}
          </span>
        </v-flex>

        <v-flex xs12 sm3 py-2>
          <span
            style="color: black; font-family: poppins-semibold; font-size: 23px"
          >
            Map
          </span>
        </v-flex>
        <v-flex xs12 sm9 py-2 align-self-center text-left>
          <v-img
            width="100%"
            height="600px"
            contain
            :src="baseURL + turtleList.mapImage"
          ></v-img>
        </v-flex>

        <v-flex xs12 py-5 align-self-center text-left>
          <span
            style="color: black; font-family: poppins-light; font-size: 23px"
          >
            Disclaimer: Maps denote non-scientific distributions of species
            across the Indian subcontinent. For further details on global
            distribution, refer to
            <a
              style="font-family: poppins-lighti; font-size: 23px"
              href="https://iucn-tftsg.org/checklist/"
              >https://iucn-tftsg.org/checklist/</a
            >
          </span>
        </v-flex>
         </v-layout>
        </v-flex>
      </v-layout>
      
      <v-layout v-if="!turtleList" wrap justify-center>
        <v-flex align-self-center text-center py-12>
          <span style="font-family: poppins-bold">No results found!!</span>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  props: ["id"],
  data() {
    return {
      ServerError:false,
      appLoading:false,
      value:false,
      showsnackbar: [],
      snackmessage: [],
      loader: null,
      dialog: true,
      turtleList: [],
      hardList: [],
      carousel:[],
      value1:false,
      item:[]
    };
  },
  // watch: {
  //   id() {
  //     this.getList();
  //     // this.runAgain()
  //   },
  // },
  beforeMount() {
    this.getList();
  },
  methods: {
    big(){
      this.value = true;
    },
    big2(item){
      this.item =item;
      this.value1 = true;
    },
    getList() {
      this.appLoading = true,
      axios({
        method: "GET",
        url: "turtle/get",
        params: { id: this.id },
      }).then((response) => {
        if (response.data.status) {
          this.turtleList = response.data.data;
          if(response.data.data.identification1 !=="" )
          {
          this.carousel.push(response.data.data.identification1);
          }
          if(response.data.data.identification2 !=="" )
          {
          this.carousel.push(response.data.data.identification2);
          }
          if(response.data.data.female_carapace !=="" )
          {
           this.carousel.push(response.data.data.female_carapace);
          }
           if(response.data.data.female_plastron !=="" )
           {
            this.carousel.push(response.data.data.female_plastron);
           }
           if(response.data.data.male_carapace !=="" ){          
              this.carousel.push(response.data.data.male_carapace);
           }
           if(response.data.data.male_plastron !=="" ){
               this.carousel.push(response.data.data.male_plastron);
           }
          console.log(this.carousel)
         
        }
        this.appLoading =false
      })
      .catch((err) => {
            console.log(err());
            this.ServerError = true;
          });
    },
    runAgain() {
      this.hardList = [];
      for (let i = 0; i < this.turtleList.length; i++) {
        if (this.turtleList[i]._id == this.id) {
          this.hardList = this.turtleList[i];
        }
        
      }
    },
  },
};
</script>
<style>
.text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>